import { render, staticRenderFns } from "./pages3.vue?vue&type=template&id=514e5189&scoped=true&"
import script from "./pages3.vue?vue&type=script&lang=js&"
export * from "./pages3.vue?vue&type=script&lang=js&"
import style0 from "./pages3.vue?vue&type=style&index=0&id=514e5189&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e5189",
  null
  
)

export default component.exports